export class SearchCorporate {
  static readonly type = '[CorporateMatching] Search Corporate';
  constructor(public payload: string) {}
}

export class SetCorporate {
  static readonly type = '[CorporateMatching] SetCorporate';
  constructor(public payload: string) {}
}
